export default "__VITE_ASSET__DBYOe4Ya__"